import { RiskTag } from '../interfaces/policies.interface';
import { InsurableMapper } from './insurableMapper';
import { ClassicCarInsurableMapper } from './risks/classicCarInsurableMapper';
import { MotorBikeInsurableMapper } from './risks/motorBikeInsurableMapper';
import { PersonalAccidentsInsurableMapper } from './risks/personalAccidentsInsurableMapper';
import { QuadInsurableMapper } from './risks/quadInsurableMapper';
import { TransportationGoodsInsurableMapper } from './risks/transportationGoodsInsurableMapper';

export const PolicyMapperRegistry: { [K in RiskTag]: InsurableMapper<unknown> } = {
  classic_car: new ClassicCarInsurableMapper(),
  motor_bike: new MotorBikeInsurableMapper(),
  transportation_goods: new TransportationGoodsInsurableMapper(),
  personal_accidents: new PersonalAccidentsInsurableMapper(),
  quad: new QuadInsurableMapper(),
};
